<template>
  <div>
    <div class="alert alert-danger" v-if="errorMessages.length > 0">
      <ul>
        <li v-for="message in errorMessages">{{ message}}</li>
      </ul>
    </div>
    <div class="panel panel-default">
      <div class="panel-heading">Commander</div>
      <form method="POST" action="#" @submit.prevent="submitOrder" class="js-form-step form-step" autocomplete="off">
        <loader-box v-if="loading"/>
        <div class="panel-body">
          <div class="js-form-step-tab form-step-tab">
            <div class="blur-overlay" v-if="!isAdmin && userId" style="background-color: rgba(0,0,0, .2)"></div>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="phone_number" class="control-label">Numéro téléphone*</label>
                  <input tabindex="-1" type="text" name="phone_number" id="phone_number" autocomplete="-1"
                         class="form-control awesomplete" placeholder="Numéro de téléphone..."
                         v-model="order.phone_number" @input="searchUser">
                  <input type="hidden" name="user_id" id="user_id" v-model="order.user_id">
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group" :class="{'is-loading': userSearching}">
                  <label for="title" class="form-label">Civilité*</label>
                  <select class="form-control" name="title" v-model="order.title" id="title">
                    <option :value="title" v-for="title in userTitles">{{ title }}</option>
                  </select>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group" :class="{'is-loading': userSearching}">
                  <label for="email" class="control-label">Email</label>
                  <input tabindex="-1" type="text" name="email" id="email" class="form-control"
                         placeholder="(optionnel)"
                         v-model="order.email">
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group" :class="{'is-loading': userSearching}">
                  <label for="first_name" class="control-label">Prénom*</label>
                  <input tabindex="-1" type="text" name="first_name" id="first_name" class="form-control"
                         v-model="order.first_name">
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group" :class="{'is-loading': userSearching}">
                  <label for="last_name" class="control-label">Nom*</label>
                  <input tabindex="-1" type="text" name="last_name" id="last_name" class="form-control"
                         v-model="order.last_name">
                </div>
              </div>
            </div>
          </div>
          <div class="js-form-step-tab form-step-tab">
            <input type="hidden" name="menu_id" id="menu_id" v-model="order.menu_id" class="form-control"/>
            <div class="form-group">
              <label for="name">Menu</label>
              <input class="form-control" type="text" disabled v-model="menu.name" id="name"/>
            </div>
            <div class="form-group">
              <label for="price">Prix unitaire:</label>
              <input class="form-control" type="text" disabled v-model="menuPrice" id="price"/>
            </div>
            <div class="number-picker">
              <label for="quantity">Quantité</label>
              <div class="number-picker-field">
            <span id="number-picker-field-minus" class="number-picker-field-minus"
                  :class="{'is-disabled': order.quantity === 1}" @click="minusQuantity">
              <i class="fa fa-minus"></i>
            </span>
                <input type="text" name="quantity" id="quantity" v-model="order.quantity"/>
                <span id="number-picker-field-plus" class="number-picker-field-plus" @click="addQuantity">
              <i class="fa fa-plus"></i>
            </span>
              </div>
            </div>
            <div class="form-group" v-if="isAdmin">
              <label>Livraison ?</label>
              <label class="radio-inline" v-for="value in Object.keys(orderShipmentTypes)">
                <input type="radio" name="shipment_type" v-model.number="order.shipment_type" :value="value"> {{
                orderShipmentTypes[value] }}
              </label>
            </div>
            <div class="form-group">
              <div>
                <label>Sous total:</label>
                <span class="text-muted">{{ parseInt(menu.price) * parseInt(order.quantity)}} FCFA</span>
              </div>
              <div v-if="orderToDeliver">
                <label>frais de livraison: </label>
                <span class="text-muted">{{ parseInt(menu.shipment_fee)}} FCFA</span>
              </div>
              <div>
                <label>Prix total: </label>
                <span class="text-muted">{{ totalPrice }} FCFA</span>
              </div>
            </div>
            <div class="form-group" v-if="orderToDeliver">
              <label for="address">Adresse livraison</label>
              <textarea name="address" id="address" class="form-control" v-model="order.address"
                        placeholder="Mettez ici votre adresse de livraison..."></textarea>
            </div>
            <transition name="fade">
              <p class="well well-sm" v-if="orderToDeliver">
                *Frais de livraison {{ menu.shipment_fee }} <br>
                Soyez certain d'avoir le montant exact du paiement. Nos livreurs ne sont pas munis de monnaie
              </p>
            </transition>
            <fieldset v-if="isAdmin">
              <legend>Client ayant passé commande</legend>
              <div class="form-group">
                <label for="orderer_name" class="control-label">Nom complet</label>
                <input type="text" v-model="ordererName" id="orderer_name" class="form-control"/>
              </div>
              <div class="form-group">
                <label for="orderer_phone" class="control-label">Numéro téléphone</label>
                <input type="text" v-model="ordererPhone" id="orderer_phone" class="form-control"/>
              </div>
            </fieldset>
            <!-- disabled for now
            <button class="btn btn-block btn-primary" @click.prevent="submitOrder(true)">Payer par OM <i
              class="fa fa-money"></i></button>
            -->
            <button class="btn btn-block btn-primary" @click.prevent="submitOrder(false)">{{ payLabel }} <i
              class="fa fa-cart-plus"></i></button>
            <button v-if="isAdmin" class="btn btn-block btn-primary" @click.prevent="submitOrder(false, 4)">Déjà payée <i
              class="fa fa-money"></i></button>
          </div>

          <div class="form-step-indicators js-form-step-indicators"></div>
          <div class="form-step-navigation">
            <button type="button" class="form-step-previous js-form-step-previous is-disabled"><i
              class="fa fa-arrow-left"></i> Précedent
            </button>
            <button type="button" class="form-step-next js-form-step-next">Suivant <i class="fa fa-arrow-right"></i>
            </button>
          </div>
        </div>
      </form>
      <div style="margin-top: 10px;" class="alert alert-warning in" v-show="order.first_name">
        Vous ne réservez pas pour {{ order.first_name }} {{ order.last_name }}?
        <strong><a href="#clear-field" @click.prevent="clearFields"> cliquer ici</a></strong>
      </div>
    </div>
  </div>
</template>

<script>
  import debounce from 'lodash.debounce'
  import Awesomplete from 'awesomplete'
  import appAxios from '../../app-axios'
  import Swal from 'sweetalert2'
  import {handleErrors, resetErrors} from '../../form'
  import FormStep from "../../form-step"
  import LoaderBox from '../../component/Loader/LoaderBox'


  const getUserOptions = function (users) {
    let options = []
    users.forEach(user =>
      options.push({
        label: `${user.first_name} ${user.last_name} - ${user.phone_number}`,
        value: user
      })
    )
    return options
  }
  export default {
    props: {
      orderUrl: {type: String},
      orderConfirmUrl: {type: String},
      userQueryUrl: {type: String},
      userUrl: {type: String},
      menu: {type: Object},
      userId: {type: Number, default: 0},
      isAdmin: {type: Boolean, default: false}
    },
    components: {LoaderBox},
    data () {
      return {
        errorMessages: [],
        userAutoComplete: {list: []},
        loading: false,
        userSearching: false,
        userTitles: ['Monsieur', 'Madame'],
        orderShipmentTypes: {
          0: 'à livrer',
          1: 'sur place',
          2: 'à emporter',
        },
        order: {
          menu_id: 0,
          user_id: 0,
          quantity: 1,
          address: '',
          shipment_type: 0,
          status: 0,
          // user fields
          first_name: '',
          last_name: '',
          email: '',
          phone_number: '',
          title: '',
          // end user field
          orderer_name: '',
          orderer_phone: '',
          // additional info
          is_paying_now: false
        }
      }
    },
    computed: {
      ordererName: {
        get () {
          return this.order.orderer_name ? this.order.orderer_name : `${this.order.first_name} ${this.order.last_name}`
        },
        set (value) {
          this.order.orderer_name = value
        }
      },
      ordererPhone: {
        get () {
          return this.order.orderer_phone ? this.order.orderer_phone : this.order.phone_number
        },
        set (value) {
          this.order.orderer_phone = value
        }
      },
      orderToDeliver () {
        return this.order.shipment_type === 0
      },
      menuPrice () {
        return this.menu.price + ' FCFA'
      },
      payLabel () {
        return this.orderToDeliver
          ? 'Payer à la livraison'
          : 'Payer sur place'
      },
      totalPrice () {
        if (this.orderToDeliver) { // to deliver
          return parseInt(this.menu.price) * parseInt(this.order.quantity) + parseInt(this.menu.shipment_fee)
        }
        return parseInt(this.menu.price) * parseInt(this.order.quantity)
      }
    },
    methods: {
      loadUser (userId) {
        return new Promise((resolve, reject) => {
          appAxios.get(this.userUrl.replace(':user', userId))
            .then(apiResponse => resolve(apiResponse.getData()))
            .catch(apiResponse => reject(apiResponse))
        })
      },
      addQuantity () {
        this.order.quantity++
      },
      minusQuantity () {
        this.order.quantity--
        if (this.order.quantity < 1) {
          this.order.quantity = 1
        }
      },
      searchUser: debounce(function () {
        if (!this.isAdmin || !this.order.phone_number) {
          // no need to do search
          return
        }
        this.userSearching = true
        appAxios.get(this.userQueryUrl.replace(':query', this.order.phone_number), this.order.phone_number.trim())
          .then(apiResponse => {
            if (apiResponse.isSuccess()) {
              this.userAutoComplete.list = getUserOptions(apiResponse.getData())
            } else {
              Swal({text: 'erreur lors du chargement des clients', type: 'warning'})
            }
          })
          .catch(err => {
            window.alert(err.message ? err.message : 'something went wrong')
            console.error(err)
            debugger
          })
          .then(() => this.userSearching = false)
      }, 600),
      submitOrder (isPayingNow, status = 0) {
        this.errorMessages = []
        resetErrors(Object.keys(this.order), {
          classList: ['has-error', 'has-success']
        })
        this.order.status = status
        this.order.is_paying_now = isPayingNow
        this.order.orderer_name = this.ordererName
        this.order.orderer_phone = this.ordererPhone
        this.loading = true
        appAxios.post(this.orderUrl, this.order)
          .then(apiResponse => {
            Swal({
              text: apiResponse.getMessage(),
              onClose: () => {
                if (this.order.is_paying_now) {
                  this.loading = true
                  window.location = this.orderConfirmUrl.replace(':order', apiResponse.getData().id)
                } else {
                  window.location = '/menu'
                }
              }
            })
          })
          .catch(apiResponse => {
            console.error(apiResponse)
            handleErrors(apiResponse.getData, Object.keys(this.order), {
              feedbackClass: 'help-block',
              errorClass: 'has-error'
            })
            Swal({text: apiResponse.getMessage(), type: 'error'})
            let errors = apiResponse.getData()
            this.errorMessages = Object.keys(errors).map(field => errors[field][0])
          })
          .then(_ => this.loading = false)
      },
      clearFields () {
        this.order.first_name = ''
        this.order.last_name = ''
        this.order.email = ''
        this.order.user_id = ''
        this.order.title = ''
        this.order.phone_number = ''
        this.formStep.goto(0)
      },
      setUpAutoComplete () {
        let self = this
        this.userAutoComplete = new Awesomplete(this.$el.querySelector('.awesomplete'), {
          minChars: 3,
          maxItems: 15,
          autoFirst: true,
          replace: function (text) {
            // clear the field to let the user enter a new value
            let user = text.value
            self.setUserFields(user)
            this.input.value = user.phone_number
            // self.order_user = this.input.value = text.label
          }
        })
      },
      setUserFields (user) {
        this.order.user_id = user.id
        this.order.first_name = user.first_name
        this.order.last_name = user.last_name
        this.order.email = user.email
        this.order.title = user.title
        this.order.phone_number = user.phone_number
      }
    },
    mounted () {
      this.order.menu_id = this.menu.id
      this.formStep = new FormStep(this.$el.querySelector('.js-form-step'))

      // no auto complete for other than admin user
      if (this.isAdmin) {
        this.setUpAutoComplete()
      } else if (this.userId) {
        // no replacing if admin neither
        this.loading = true
        appAxios.get(this.userUrl.replace(':user', this.userId))
          .then(apiResponse => {
            this.setUserFields(apiResponse.getData())
          })
          .catch(apiResponse => {
            console.error(apiResponse)
            Swal(apiResponse.getMessage(), 'warning')
          })
          .then(_ => this.loading = false)
      }
    }
  }
</script>

<style lang="scss">
  @import '~awesomplete/awesomplete.css';

  .awesomplete {
    display: block;
  }

  .well-sm {
    font-size: .9rem;
  }

  .text-muted {
    float: right;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/component/Order/OrderCreate.vue